import { render, staticRenderFns } from "./TypeSelector.vue?vue&type=template&id=fb324480&scoped=true"
import script from "./TypeSelector.vue?vue&type=script&lang=ts"
export * from "./TypeSelector.vue?vue&type=script&lang=ts"
import style0 from "./TypeSelector.vue?vue&type=style&index=0&id=fb324480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb324480",
  null
  
)

export default component.exports